import { useFeatureFlag } from "../../../launch-darkly";
import usePlannerMetaData from "../../web-app-calendar/hooks/usePlannerMetaData";
import { useEventsSearch } from "./useEventsSearch";
import { useSearchPersonsChat } from "./useSearchPersons";

export const useMentionsSearch = () => {
  const [isOnAIChatNUX] = useFeatureFlag("AIChatNUX");

  const {
    searchPersons,
    handlePersonSearch,
    resetSearch: resetPersonSearch,
    setShowEmptyState: setShowEmptyPersonState,
  } = useSearchPersonsChat({});

  const { primaryCalendarId } = usePlannerMetaData();
  const {
    handleEventSearch,
    resetSearchEvents,
    searchEvents,
    setShowEventSearchEmptyState,
  } = useEventsSearch(primaryCalendarId);

  const resetSearch = () => {
    resetPersonSearch();
    resetSearchEvents();
  };

  const setShowEmptySearchState = (isEmptyState: boolean) => {
    setShowEmptyPersonState(isEmptyState);
    setShowEventSearchEmptyState(isEmptyState);
  };

  const handleMentionSearch = (input: string) => {
    if (isOnAIChatNUX) {
      handleEventSearch(input);
    }
    handlePersonSearch(input, []);
  };

  return {
    searchPersons,
    handleMentionSearch,
    resetSearch,
    setShowEmptySearchState,
    searchEvents: isOnAIChatNUX ? searchEvents : [],
  };
};
